
const ValuesSection = () => {
  const values = [
    {
      icon: 'ri-heart-line',
      title: 'Integrity',
      description: 'We conduct every transaction with complete honesty and transparency. Your trust is the foundation of our relationship, and we never take that lightly.'
    },
    {
      icon: 'ri-shield-user-line',
      title: 'Stewardship',
      description: 'We see ourselves as caretakers of the businesses we acquire. Our role is to preserve and enhance what you\'ve built, not to strip it down or change its character.'
    },
    {
      icon: 'ri-time-line',
      title: 'Long-Term Focus',
      description: 'We\'re not looking for quick flips or short-term gains. We invest in businesses for the long haul, ensuring they continue to serve their communities for generations.'
    }
  ];

  return (
    <section className="py-20 bg-soft-gray">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-playfair text-4xl font-bold text-navy mb-4">
            Our Values
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            These principles guide every decision we make and every relationship we build.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div key={index} className="bg-white rounded-lg p-8 shadow-sm hover:shadow-lg transition-shadow duration-300">
              <div className="w-16 h-16 flex items-center justify-center bg-[#C9A227] rounded-full mb-6">
                <i className={`${value.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="font-playfair text-2xl font-semibold text-navy mb-4">
                {value.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-navy rounded-lg p-8">
            <h3 className="font-playfair text-2xl font-semibold text-white mb-4">
              Our Vision
            </h3>
            <p className="text-gray-200 text-lg leading-relaxed max-w-4xl mx-auto">
              To build a portfolio of enduring, people-first businesses that keep serving their communities long after the founder steps away.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
